import React from "react";

import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";

import { CLIENT_TEMPLATE } from "utils/options/CLIENT_TEMPLATE";
import { systemStatusOptions } from "utils/options/systemStatusOptions";

const templateType = CLIENT_TEMPLATE;

export default function System({
  client,
  FORM_MODE,
  paymentMethods,
  handleInputChange,
}) {
  
  return (
    <Grid container spacing={2}>
      <Grid item xs={12} sm={6} md={4}>
        <TextField
          disabled
          name="ID"
          label="ID"
          value={client?.Id}
          onChange={(e) => handleInputChange("Id", e.target.value)}
          size="small"
          fullWidth
          margin="dense"
        />
      </Grid>
      <Grid item xs={12} sm={6} md={4}>
        <FormControl margin="dense" fullWidth sx={{ textAlign: "left" }}>
          <InputLabel>Klientmall typ</InputLabel>
          <Select
            name="Template"
            disabled={FORM_MODE === "LOCKED" ? true : false}
            value={client.Template}
            onChange={(e) => handleInputChange("Template", e.target.value)}
            label="Klientmall typ"
            size="small"
          >
            {templateType.map((type) => (
              <MenuItem key={type.Value + "_" + type.Name} value={type.Value}>
                {type.Name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Grid>
      <Grid item xs={12} sm={6} md={4}>
        <TextField
          disabled={true}
          name="ParseStatus"
          label="Kontrollstatus"
          value={client.ParseStatus}
          size="small"
          fullWidth
          margin="dense"
        />
      </Grid>
      <Grid item xs={12} sm={6} md={4}>
        <TextField
          disabled={true}
          name="ParseMessage"
          label="Kontrollmeddelande"
          value={client.ParseMessage}
          size="small"
          fullWidth
          margin="dense"
        />
      </Grid>
      <Grid item xs={12} sm={6} md={4}>
        <FormControl margin="dense" fullWidth sx={{ textAlign: "left" }}>
          <InputLabel>Status</InputLabel>
          <Select
            name="SystemStatus"
            disabled={FORM_MODE === "LOCKED" ? true : false}
            value={client.SystemStatus}
            onChange={(e) => handleInputChange("SystemStatus", e.target.value)}
            label="SystemStatus"
            size="small"
          >
            {systemStatusOptions.map((options) => (
              <MenuItem key={options.Value} value={options.Value}>
                {options.Name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Grid>
      <Grid item xs={12} sm={6} md={4}>
        <TextField
          name="Skapad"
          label="Skapad"
          value={client.CreateTime}
          size="small"
          color="primary"
          fullWidth
          margin="dense"
          disabled
        />
      </Grid>
    </Grid>
  );
}
